import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: { width: '100%' },
  legend: {
    fontSize: 12,
    marginBottom: theme.spacing(0.5)
  },
  group: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5)
  },
  day: {
    marginRight: theme.spacing(1),
    marginLeft: 0
  },
  helper: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5)
  }
}))

export default useStyles
